import React, { useEffect, useState } from 'react';
import { API_HOST } from '../../consts';
import axios from 'axios';

const ProviderLogin = ({ match }) => {
	const [errorMessage, setErrorMessage] = useState(null);

	useEffect(() => {
		const requestBody = {
			token: match.params.token,
		};
		if (requestBody.token !== undefined && match.params.provider !== undefined) {
			axios
				.post(`${API_HOST}/login/provider/${match.params.provider}/login`, requestBody)
				.then((response) => {
					localStorage.setItem('token', response.data.token);
					window.location.replace(`/instrumentos-cognitivos/${match.params.avaliacao_id}/itens`);
				})
				.catch((error) => {
					console.error('Erro na requisição:', error);
					setErrorMessage('Acesso não permitido - usuário não cadastrado na plataforma.');
				});
		}
	}, []);

	return (
		<div className="error-container">
			{errorMessage && <p className="error-message">{errorMessage}</p>}
			<style>
				{`
          .error-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            flex-direction: column;
          }
          
          .error-message {
            background-color: #ff0000;
            color: #fff;
            padding: 20px;
            border-radius: 5px;
            font-size: 18px;
            text-align: center;
          }
        `}
			</style>
		</div>
	);
};

export default ProviderLogin;





